// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610261134/js/" + chunkId + "." + {"44":"7ae48d26","225":"da2eb5ea","481":"7e04f221","486":"43156711","770":"72ff91ac"}[chunkId] + ".0.6762765797512541.chunk.js";
};